<template>
  <div class="body-skeleton">
    <b-container class="body-skeleton__header" fluid>
      <b-skeleton
        class="body-skeleton__actions px-auto"
        animation="wave"
      ></b-skeleton>
      <b-row>
        <b-col cols="auto" class="mx-auto">
          <b-skeleton
            class="body-skeleton__avatar"
            type="avatar"
            animation="wave"
          ></b-skeleton>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="auto" class="mx-auto">
          <b-skeleton
            class="body-skeleton__line"
            animation="wave"
            width="30em"
            height="3em"
          ></b-skeleton>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="auto" class="mx-auto">
          <b-skeleton
            class="body-skeleton__line"
            animation="wave"
            width="25em"
            height="2.1em"
          ></b-skeleton>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="auto" class="mx-auto">
          <b-skeleton
            class="body-skeleton__line"
            animation="wave"
            width="30em"
            height="2.1em"
          ></b-skeleton>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="body-skeleton__body" fluid>
      <b-row>
        <b-col>
          <b-skeleton
            class="body-skeleton__line"
            animation="wave"
            width="100%"
            height="4em"
          ></b-skeleton>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-skeleton
            class="body-skeleton__line"
            animation="wave"
            width="65%"
            height="3em"
          ></b-skeleton>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-skeleton
            class="body-skeleton__line"
            animation="wave"
            width="15em"
            height="2.1em"
          ></b-skeleton>
        </b-col>
      </b-row>
      <b-row class="body-skeleton__images body-skeleton__line">
        <b-col>
          <b-skeleton-img height="15em"></b-skeleton-img>
        </b-col>
        <b-col>
          <b-skeleton-img height="15em"></b-skeleton-img>
        </b-col>
        <b-col>
          <b-skeleton-img height="15em"></b-skeleton-img>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "BodySkeleton",
};
</script>
